__turbopack_context__.v({
  "filters": "TournamentScorerFilters-module__DG8iXW__filters",
});
